import { AcademicPeriodType } from "../../../types/AcademicPeriod";
import { put } from "../../../utils/axios-config";
import { ACADEMIC_PERIODS } from "../../../utils/constants";

export const updateAcademicPeriod = async (data:AcademicPeriodType) => {
    return await put<AcademicPeriodType, boolean>(ACADEMIC_PERIODS, data);
};